import { GroupInterface } from "@/interfaces/Group.interface";
import api from "@/services/config";

export class GroupRest{
    getGroups(params: any): Promise<any> {
        return api.get('/group', { params }).then((response) => response.data);
    }

    getGroupById(id: any): Promise<any> {
        return api.get(`/group/${id}`).then((response) => response.data);
    }

    addGroup(data: any): Promise<any> {
        return api.post('/group', data).then((response) => response.data);
    }

    updateGroup(id: any, data: any): Promise<any> {
        return api.put(`/group/${id}`, data).then((response) => response.data);
    }

    deleteGroup(id: any): Promise<GroupInterface> {
        return api.delete(`/group/${id}`).then((response) => response.data);
    }

    addOrganizationToGroup(id: string, organizationId: string): Promise<any> {
        return api.post(`/group/addOrganization?id=${id}&organzationId=${organizationId}`).then((response) => response.data);
    }

    removeOrganizationFromGroup(data: any): Promise<any> {
        
        return api.delete(`/group/removeOrganization`, {data}).then((response) => response.data);
    }
}